import { render, staticRenderFns } from "./SecondPage.vue?vue&type=template&id=3dfd383e&scoped=true&"
import script from "./SecondPage.vue?vue&type=script&lang=js&"
export * from "./SecondPage.vue?vue&type=script&lang=js&"
import style0 from "./SecondPage.vue?vue&type=style&index=0&id=3dfd383e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfd383e",
  null
  
)

export default component.exports